export default __webpack_public_path__ + "static/media/img2.879b0c0e.png";